import * as z from 'zod';

export const addressSchema = {
  /**
   * Primary street address (street number and street name).
   *
   * @example "123 Maple Street"
   */
  addressLine1: z.string().nonempty(),

  /**
   * Secondary address information such as apartment, unit, or suite. Optional.
   *
   * @example "Unit 5" or "Suite 200"
   */
  addressLine2: z.string().optional(),

  /**
   * City or municipality name.
   *
   * @example "Vancouver"
   */
  city: z.string().nonempty(),

  /**
   * Province or territory (full name or standard two-letter abbreviation).
   *
   * @example "British Columbia" or "BC"
   */
  state: z.string().nonempty(),

  /**
   * Postal code in the local format.
   *
   * @example "Canadian: A1A 1A1"
   */
  postalCode: z.string().nonempty(),

  /**
   * Country name.
   *
   * @example "Canada"
   */
  country: z.string().nonempty(),
};

export type Address = z.infer<z.ZodObject<typeof addressSchema>>;

// export class Address {
//   /**
//    * Primary street address (street number and street name).
//    *
//    * @example "123 Maple Street"
//    */
//   readonly addressLine1: string;

//   /**
//    * Secondary address information such as apartment, unit, or suite. Optional.
//    *
//    * @example "Unit 5" or "Suite 200"
//    */
//   readonly addressLine2?: string;

//   /**
//    * City or municipality name.
//    *
//    * @example "Vancouver"
//    */
//   readonly city: string;

//   /**
//    * Province or territory (full name or standard two-letter abbreviation).
//    *
//    * @example "British Columbia" or "BC"
//    */
//   readonly state: string;

//   /**
//    * Canadian postal code in the format A1A 1A1 (letter-number-letter space number-letter-number).
//    *
//    * @example "A1A 1A1"
//    */
//   readonly postalCode: string;

//   /**
//    * Country name.
//    *
//    * @example "Canada"
//    */
//   readonly country: string;

//   constructor({
//     addressLine1,
//     addressLine2,
//     city,
//     state,
//     postalCode,
//     country,
//   }: Address) {
//     this.addressLine1 = addressLine1;
//     this.addressLine2 = addressLine2;
//     this.city = city;
//     this.state = state;
//     this.postalCode = postalCode;
//     this.country = country;
//   }

//   toString(): string {
//     let combinedAddressLines = this.addressLine1;

//     // prepend addressLine2 if it exists
//     if (isString(this.addressLine2)) {
//       combinedAddressLines = `${this.addressLine2} - ${combinedAddressLines}`;
//     }

//     combinedAddressLines = `${combinedAddressLines}, ${this.city}, ${this.state} ${this.postalCode}, ${this.country}`;

//     return combinedAddressLines;
//   }
// }
